import ClearRoundedIcon from '@mui/icons-material/ClearRounded'
import { FC } from 'react'
import { Button } from 'ui'

import styles from './RemoveAddressBtn.module.scss'

interface IRemoveAddressBtn {
  setModalOpen: (arg0: boolean) => void
}

// кнопка для удаления адреса
export const RemoveAddressBtn: FC<IRemoveAddressBtn> = ({ setModalOpen }) => {
  return (
    <Button
      variant='text'
      startIcon={<ClearRoundedIcon />}
      className={styles.removeBtn}
      onClick={() => setModalOpen(true)}
      data-testid='address-remove-btn'
    >
      Удалить адрес
    </Button>
  )
}
